import React from "react";

const AttachedFileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    {...props}
  >
    <path
      d="M6.375 1.25C4.86035 1.25 3.625 2.45944 3.625 3.94231V16.0577C3.625 17.5406 4.86035 18.75 6.375 18.75H14.625C16.1396 18.75 17.375 17.5406 17.375 16.0577V6.63462C17.375 5.91947 16.7063 5.24114 15.5059 4.08954C15.3394 3.92916 15.1594 3.75038 14.9902 3.58474C14.821 3.4191 14.6384 3.26397 14.4746 3.10096C13.2983 1.92571 12.6055 1.25 11.875 1.25H6.375ZM6.375 2.59615H11.3809C11.8777 2.71973 11.875 3.30341 11.875 3.90024V5.96154C11.875 6.33226 12.1838 6.63462 12.5625 6.63462H14.625C15.3098 6.63462 16 6.63724 16 7.30769V16.0577C16 16.8018 15.385 17.4038 14.625 17.4038H6.375C5.61499 17.4038 5 16.8018 5 16.0577V3.94231C5 3.19824 5.61499 2.59615 6.375 2.59615Z"
      fill="#6D707B"
    />
  </svg>
);

export default AttachedFileIcon;
